import { render, staticRenderFns } from "./billBox.vue?vue&type=template&id=5d51deb0&scoped=true"
import script from "./billBox.vue?vue&type=script&lang=js"
export * from "./billBox.vue?vue&type=script&lang=js"
import style0 from "./billBox.vue?vue&type=style&index=0&id=5d51deb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51deb0",
  null
  
)

export default component.exports